import { withTranslation } from './with-translation';
import { withExperiments } from './with-experiments';
import { withPermissions } from './with-permissions';
class Composer {
    constructor() {
        this.funcs = [];
    }
    withTranslation() {
        this.funcs.push(withTranslation);
        return this;
    }
    withExperiments() {
        this.funcs.push(withExperiments);
        return this;
    }
    withPermissions() {
        this.funcs.push(withPermissions);
        return this;
    }
    compose(val) {
        return this.funcs.reduceRight((prevComposition, func) => func(prevComposition), val);
    }
}
export const composer = () => new Composer();
//# sourceMappingURL=composer.js.map